import { render } from "./MatriculasYBecasList.vue?vue&type=template&id=fb7be22e"
import script from "./MatriculasYBecasList.vue?vue&type=script&lang=js"
export * from "./MatriculasYBecasList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__